module.exports = __webpack_public_path__ + "img/download.7453d282.svg";